export const RECAPTCHA_KEY = "6LfO-NIhAAAAADaRoeRv62smh7kvqk_7yiVTp7RH";
